import { FC } from 'react'
import { SecondaryButton } from '@/ui/routes/mdr/routes/overview/components/ScheduleCall/ScheduleCall.styles'
import PlayIcon from '@assets/images/play-icon.svg?react'
import Typography from '@/ui/components/typography'
import { PlayButtonProps } from './PlayButton.types'

export const PlayButton: FC<PlayButtonProps> = ({
    onClick,
    text,
    dataTestId,
    buttonSize = 'regular',
}) => {
    return (
        <SecondaryButton onClick={onClick} data-testid={dataTestId}>
            <PlayIcon height={20} width={20} />
            <Typography
                variant={buttonSize === 'small' ? 's-regular' : 'm-regular'}
                component="p"
            >
                {text}
            </Typography>
        </SecondaryButton>
    )
}

export default PlayButton
